// src/components/dashboard/MetricCard.jsx

import React, { useState } from 'react';
import { COLORS } from '../../constants';
import { PAGE, getCardStyle } from '../ui';
import { Icons } from './Icons';

export default function MetricCard({
  title,
  value,
  subtitle,
  icon,
  color = COLORS.blue,
}) {
  const [hovered, setHovered] = useState(false);
  const IconComponent = Icons[icon];

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...getCardStyle(),
        padding: '12px 14px',
        minHeight: '118px',
        border: `1px solid ${hovered ? color : PAGE.colors.line}`,
        transition: 'all 0.25s ease',
        transform: hovered ? 'translateY(-2px)' : 'none',
        boxShadow: hovered
          ? '0 8px 18px rgba(0,0,0,0.08)'
          : '0 2px 8px rgba(0,0,0,0.04)',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 8,
          gap: 8,
        }}
      >
        <span
          style={{
            ...PAGE.type.cardLabel,
            letterSpacing: '0.5px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '14px',
          }}
        >
          {title}
        </span>

        <span
          style={{
            color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'scale(0.8)',
            transformOrigin: 'top right',
          }}
        >
          {IconComponent && <IconComponent />}
        </span>
      </div>

      <div
        style={{
          fontSize: 28,
          fontWeight: 800,
          color: PAGE.colors.heading,
          marginBottom: 4,
          lineHeight: 1,
        }}
      >
        {value}
      </div>

      {subtitle && (
        <div
          style={{
            ...PAGE.type.sectionSubtitle,
            margin: 0,
            fontSize: 11,
            lineHeight: '14px',
          }}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
}